import ElementView from '../../components/ElementView'
import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import { useParams } from 'react-router-dom'
import { useProject } from '../../context/ProjectContext'


export default function ElementViewPage({ setBlockScreen }: any) {
  const params = useParams<{ element_code?: string }>()
  const element_code = params.element_code ?? ''
  const { isProjectUndefined } = useProject()

  return (<>
    <TopSideBar currentSection='elements' disableProjectSelector />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Link underline="hover" color="darkgreen" href="/elements/listing">
            Elementos
          </Link>
          <Typography color="darkgreen" fontWeight={"bold"}>
            Detalle
          </Typography>
        </Breadcrumbs>
      </Grid>

      {!isProjectUndefined() && (
        <ElementView
          element_code={element_code}
          setBlockScreen={setBlockScreen}
        />
      )}
    </PageContainer>
  </>)
}
